import React from 'react';
import OnePagePortfolio from './OnePagePortfolio';

function App() {
  return <OnePagePortfolio />;
}

export default App;